import React from "react";

import {
  FaCheckCircle,
  FaFileAlt,
  FaWhatsapp,
  FaComments,
} from "react-icons/fa";

import Section from "./Section";

const WhyCohopSection: React.FC = () => {
  return (
    <Section id="why-cohop" height="full" className="border-b border-pink-200">
      <div className="max-w-6xl w-full space-y-16">
        {/* Why Cohop */}
        <div className="flex flex-col md:flex-row max-w-5xl w-full space-y-6 md:space-y-0 md:space-x-6 items-center mx-auto">
          <div className="md:w-1/2 space-y-6 px-6 md:px-0">
            <h2 className="text-3xl md:text-4xl font-display font-bold text-purple-800 leading-tight">
              Built for women who love to travel, connect, and feel safe.
            </h2>
            <div className="space-y-4">
              <p className="text-purple-700 text-lg leading-relaxed">
                Cohop is India&apos;s first verified travel community for women
                — where you can talk, plan, and explore with other solo female
                travellers.
              </p>
              <p className="text-purple-700 text-lg leading-relaxed">
                Whether you&apos;re flying to a new city, finding weekend
                getaways, or just looking for safe travel tips — Cohop connects
                you with real women, verified by our team.
              </p>
            </div>
          </div>
          <div className="md:w-1/2 space-y-4">
            <div className="bg-white/80 backdrop-blur-lg rounded-2xl p-6 border border-pink-200 shadow-xl hover:shadow-2xl hover:border-purple-300 hover:-translate-y-1 transition-all duration-300">
              <h3 className="text-xl font-bold text-purple-800 mb-3 font-display">
                Connect with Travellers
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Meet verified women travelling solo to your city.
              </p>
            </div>
            <div className="bg-white/80 backdrop-blur-lg rounded-2xl p-6 border border-pink-200 shadow-xl hover:shadow-2xl hover:border-purple-300 hover:-translate-y-1 transition-all duration-300">
              <h3 className="text-xl font-bold text-purple-800 mb-3 font-display">
                Join the Conversation
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Discuss safety, share tips, and weekend plans.
              </p>
            </div>
            <div className="bg-white/80 backdrop-blur-lg rounded-2xl p-6 border border-pink-200 shadow-xl hover:shadow-2xl hover:border-purple-300 hover:-translate-y-1 transition-all duration-300">
              <h3 className="text-xl font-bold text-purple-800 mb-3 font-display">
                Discover Things to Do
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Explore events, trips, and safe destinations curated for you.
              </p>
            </div>
            <div className="pt-4 md:hidden">
              <a
                href="#signup-form"
                className="inline-block w-full bg-gradient-to-r from-pink-500 to-purple-500 text-white px-6 py-3 rounded-xl shadow-lg font-bold text-center hover:from-pink-600 hover:to-purple-600 hover:shadow-xl transition-all duration-300"
              >
                Join your city&apos;s travel circle today
              </a>
            </div>
          </div>
        </div>

        {/* Visual Divider */}
        <div className="flex items-center justify-center">
          <div className="h-px bg-gradient-to-r from-transparent via-pink-300 to-transparent w-full max-w-md"></div>
        </div>

        {/* How It Works */}
        <div className="text-center">
          <h3 className="text-3xl font-semibold mb-12 text-purple-800 font-display">
            How it works — simple, safe, and trusted.
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white/80 backdrop-blur-lg rounded-2xl p-6 border border-pink-200 shadow-xl hover:shadow-2xl hover:border-purple-300 hover:-translate-y-2 transition-all duration-300 cursor-pointer relative">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-8 h-8 bg-gradient-to-r from-pink-400 to-purple-500 text-white rounded-full flex items-center justify-center font-bold text-lg shadow-md">
                1
              </div>
              <FaFileAlt className="mx-auto text-4xl mb-4 mt-4 text-purple-500 hover:text-purple-700 transition-colors duration-300" />
              <p className="text-gray-700 font-semibold text-lg mb-2 hover:text-purple-800 transition-colors duration-300 font-display">
                Fill your name & WhatsApp number.
              </p>
            </div>
            <div className="bg-white/80 backdrop-blur-lg rounded-2xl p-6 border border-pink-200 shadow-xl hover:shadow-2xl hover:border-purple-300 hover:-translate-y-2 transition-all duration-300 cursor-pointer relative">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-8 h-8 bg-gradient-to-r from-pink-400 to-purple-500 text-white rounded-full flex items-center justify-center font-bold text-lg shadow-md">
                2
              </div>
              <FaCheckCircle className="mx-auto text-4xl mb-4 mt-4 text-purple-500 hover:text-purple-700 transition-colors duration-300" />
              <p className="text-gray-700 font-semibold text-lg mb-2 hover:text-purple-800 transition-colors duration-300 font-display">
                Our team verifies your details.
              </p>
            </div>
            <div className="bg-white/80 backdrop-blur-lg rounded-2xl p-6 border border-pink-200 shadow-xl hover:shadow-2xl hover:border-purple-300 hover:-translate-y-2 transition-all duration-300 cursor-pointer relative">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-8 h-8 bg-gradient-to-r from-pink-400 to-purple-500 text-white rounded-full flex items-center justify-center font-bold text-lg shadow-md">
                3
              </div>
              <FaWhatsapp className="mx-auto text-4xl mb-4 mt-4 text-purple-500 hover:text-purple-700 transition-colors duration-300" />
              <p className="text-gray-700 font-semibold text-lg mb-2 hover:text-purple-800 transition-colors duration-300 font-display">
                You&apos;re added to your city&apos;s women-only group.
              </p>
            </div>
            <div className="bg-white/80 backdrop-blur-lg rounded-2xl p-6 border border-pink-200 shadow-xl hover:shadow-2xl hover:border-purple-300 hover:-translate-y-2 transition-all duration-300 cursor-pointer relative">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-8 h-8 bg-gradient-to-r from-pink-400 to-purple-500 text-white rounded-full flex items-center justify-center font-bold text-lg shadow-md">
                4
              </div>
              <FaComments className="mx-auto text-4xl mb-4 mt-4 text-purple-500 hover:text-purple-700 transition-colors duration-300" />
              <p className="text-gray-700 font-semibold text-lg mb-2 hover:text-purple-800 transition-colors duration-300 font-display">
                Connect with travellers, share tips, and explore together.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default WhyCohopSection;
